import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../../packages/kiti/components/presentation/Text'
import FieldValuesFormSection from '../../../../containers/fieldValues/form/FieldValuesFormSection'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import GalleryInput from '../../../../components/form/GalleryInput'
import Line from '../../../../packages/kiti/components/helpers/Line'
import MarkdownEditor from '../../../../packages/kiti-editor/components/markdown/MarkdownEditor'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import { useTranslation } from 'react-i18next'

const GeneralSection = () => {
  const { t } = useTranslation('editServiceOrder')

  return (
    <>
      <Separator weight={2} />
      <Title size="xxsmall" bold color="dark3">
        {t('additionalFields')}
      </Title>
      <Line />
      <Separator weight={4} />

      <FieldValuesFormSection origin="service_orders" hideTitle />

      <Grid paddingGutter={0.5} wrap>
        <Col width="100%">
          <FormItem label={t('description')} field="description" Input={MarkdownEditor} />
        </Col>

        <Col width="100%">
          <FormItem field="documents" Input={GalleryInput} buttonLabel={t('addFile')} />
        </Col>
      </Grid>
    </>
  )
}

export default GeneralSection
